import { SecondaryMarketLoadingStatus } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

export function combineStatus(
  someStatus: SecondaryMarketLoadingStatus,
  anotherStatus: SecondaryMarketLoadingStatus,
): SecondaryMarketLoadingStatus {
  if (someStatus === 'loaded' && anotherStatus === 'loaded') {
    return 'loaded';
  }
  if (someStatus === 'failed' || anotherStatus === 'failed') {
    return 'failed';
  }
  if (someStatus === 'loading' || anotherStatus === 'loading') {
    return 'loading';
  }
  if (someStatus === 'loaded') {
    return anotherStatus;
  }
  return someStatus;
}
